import { CircleHelp, Rocket, CreditCard, FileText, FileBarChart, Wrench, Plug, Bug, Tag } from 'lucide-react';
import { LUCIDE_ICON_MAP } from '../utils/iconUtils';

export const FAQ_CATEGORIES = [
  { value: 'General', label: 'General', icon: CircleHelp },
  { value: 'Getting Started', label: 'Getting Started', icon: Rocket },
  { value: 'Account & Billing', label: 'Account & Billing', icon: CreditCard },
  { value: 'Forms & Submissions', label: 'Forms & Submissions', icon: FileText },
  { value: 'Reports & PDF', label: 'Reports & PDF', icon: FileBarChart },
  { value: 'Technical', label: 'Technical', icon: Wrench },
  { value: 'Integrations', label: 'Integrations', icon: Plug },
  { value: 'Troubleshooting', label: 'Troubleshooting', icon: Bug },
];

// Default icon names for predefined categories (used for auto-populating icon picker)
export const DEFAULT_CATEGORY_ICONS = {
  'General': 'help-circle',
  'Getting Started': 'rocket',
  'Account & Billing': 'credit-card',
  'Forms & Submissions': 'file-text',
  'Reports & PDF': 'bar-chart-3',
  'Technical': 'wrench',
  'Integrations': 'plug',
  'Troubleshooting': 'bug',
};

export const getCategoryIcon = (category, iconOverride = null) => {
  // If there's an icon override string, resolve it from LUCIDE_ICON_MAP
  if (iconOverride && LUCIDE_ICON_MAP[iconOverride]) {
    return LUCIDE_ICON_MAP[iconOverride];
  }
  const found = FAQ_CATEGORIES.find(c => c.value === category);
  return found ? found.icon : Tag;
};
